var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 98,
    viewBox: "0 0 126 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_491_7266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4133 64.5L62.9556 37.8425L106.498 64.6837L62.9556 89.7354L19.4133 64.5Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7334 2.47083L106.498 27.1767V64.9413L62.7334 40.5884V2.47083Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.178 2.47083L19.4133 27.1767V64.9413L63.178 40.5884V2.47083Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.178 51.8824L19.4133 27.1765V64.9412L63.178 90V51.8824Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3922 2.47055L20.6275 27.1764L5.09814 25.7646L48.5098 -3.8147e-05L64.3922 2.47055Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7121 2.47067L106.477 27.1765L122.006 25.7648L78.5944 8.39233e-05L62.7121 2.47067Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7334 51.8824L106.498 27.1765V64.9412L62.7334 90V51.8824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.699 73.8519V36.4402L43.1695 41.0284V78.7931L34.699 73.8519Z",
    fill: "#7F23F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2288 73.2386V35.8269L83.7582 40.4151V78.1798L92.2288 73.2386Z",
    fill: "#7F23F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2874 51.8824L19.5228 27.1765L3.99341 43.0588L47.4051 68.8235L63.2874 51.8824Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7123 51.8824L106.477 27.1765L122.006 43.0588L78.5946 68.8235L62.7123 51.8824Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_491_7266",
    x: -0.0065918,
    y: 0,
    width: 126.013,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_7266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_7266",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon_cart.9afa0ff8a82f0ed4b1796ae9c546943e.svg";
export { ForwardRef as ReactComponent };